import React, { memo } from 'react'
import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { array, func, object } from 'prop-types'

import FiltersWrapperWithTags from '../FiltersWrapperWithTags/FiltersWrapperWithTags'

import WithListingPageContext from '../../WithListingPageContext'

function ModelType({
  currentSelectedFilters,
  currentlySelectedFiltersObjects,
  setMultipleFilters,
  currentFilters,
  trackFilterChange,
}) {
  function handleFilterChange(selectedValues, value, isOn, resetAll) {
    if (resetAll) {
      window.removeCurrentSearchFilter({ name: 'modelType' })
    } else {
      if (value && isOn) {
        trackFilterChange({ name: 'modelType', value })
      } else {
        window.removeCurrentSearchFilter({ name: 'modelType', value })
      }
    }

    const truthyValues = selectedValues.filter(Boolean)
    const newFiltersEntries = truthyValues.map((v) => [v, '1'])
    const newFilters = Object.fromEntries(newFiltersEntries)

    return setMultipleFilters({ name: 'modelType', value: newFilters })
  }

  function getContent() {
    return (
      <FiltersSidebar
        isCollapsible={false}
        filters={[currentFilters]}
        selectedFilters={currentSelectedFilters}
        onFiltersChange={handleFilterChange}
        isControlled
        hideLastDivider
        useNewCheckboxes
      />
    )
  }

  return (
    <FiltersWrapperWithTags
      currentlySelectedFiltersObjects={currentlySelectedFiltersObjects || []}
      placeholder={currentFilters.label}
      type="model-type"
      content={getContent()}
      handleFilterChange={handleFilterChange}
    />
  )
}

ModelType.propTypes = {
  currentSelectedFilters: array.isRequired,
  currentlySelectedFiltersObjects: array.isRequired,
  setMultipleFilters: func.isRequired,
  currentFilters: object.isRequired,
  trackFilterChange: func.isRequired,
}

const mapStateToProps = ({
  selectedFilters,
  setMultipleFilters,
  filtersOptions,
  trackFilterChange,
}) => {
  const currentFilters = {
    ...filtersOptions.modelType,
    filters: filtersOptions.modelType.filters.map(({ value, label }) => ({ value, label })),
  }
  const groupsSelectedFilters = selectedFilters.modelType || []
  const currentSelectedFilters = getSelectedFilters(groupsSelectedFilters)
  const groupsFilters = currentFilters.filters || []
  const currentlySelectedFiltersObjects = getSelectedFiltersObjects(currentSelectedFilters)

  function getSelectedFilters(filters = []) {
    return Object.keys(filters).reduce((acc, filter) => {
      if (filters[filter] === '1') {
        return [...acc, filter]
      }

      return acc
    }, [])
  }

  function getSelectedFiltersObjects(filters = []) {
    return filters.map((filter) => {
      const filterObject = groupsFilters.find(({ value }) => value === filter)

      return filterObject || {}
    })
  }

  return {
    currentSelectedFilters,
    currentlySelectedFiltersObjects,
    setMultipleFilters,
    currentFilters: {
      ...currentFilters,
      filters: groupsFilters,
    },
    trackFilterChange,
  }
}

const shouldComponentAvoidRender = (prevProps, newProps) => {
  const {
    currentSelectedFilters: prevSelectedFilters,
    currentFilters: prevFilters,
  } = prevProps

  const {
    currentSelectedFilters: newSelectedFilters,
    currentFilters: newFilters,
  } = newProps

  function getRaw(entry) {
    return JSON.stringify(entry)
  }

  const prevCounts = prevFilters.filters
    .map(({ count }) => count)
    .filter(Number)

  const newCounts = newFilters.filters
    .map(({ count }) => count)
    .filter(Number)

  const isLengthSame = prevSelectedFilters.length === newSelectedFilters.length

  const isValueSame = getRaw(prevSelectedFilters) === getRaw(newSelectedFilters)

  const areCountsSame = getRaw(prevCounts) === getRaw(newCounts)

  if (isValueSame && isLengthSame && areCountsSame) {
    return true
  }

  return false
}

export default WithListingPageContext(mapStateToProps)(
  memo(ModelType, shouldComponentAvoidRender)
)
